/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import './Flagged.scss';

import { getFontColorClassNameOLD, colorClassNames } from '../../../styles/Colors';

const FlaggedIcon = (props) => {
  return (
    <div className="cmp-flaggedicon">
      <div className="__border border-color-gsLightest" />
      <div className={`__fill ${props.className}`} />
    </div>
  );
};
const NotFlaggedIcon = () => {
  return (
    <div className="cmp-flaggedicon">
      <div className="__border border-color-gsLightest" />
    </div>
  );
};
const FlaggedControlIcon = (props) => {
  const { isFlagged, flaggedClassName, unFlaggedClassName } = props;
  return isFlagged ? (
    <FlaggedIcon className={flaggedClassName} />
  ) : (
    <NotFlaggedIcon />
  );
};

const FlaggedControlText = (props) => {
  const { id, isFlagged, className } = props;
  return (
    <label htmlFor={id} className={classnames('font-caption-1', className)}>
      {
        isFlagged ? <FormattedMessage id="flag.flagStatusOn.button.label" /> : <FormattedMessage id="flag.flagStatusOff.button.label" />
      }
    </label>
  );
};

interface FlagToggleHorizontalProps {
  isFlagged: boolean;
  onClick(): void;
  colorTheme: string;
}
export const FlaggedControlHorizontal: React.FC<FlagToggleHorizontalProps> = (props) => {
  const { isFlagged, colorTheme, onClick } = props;

  return (
    <div id="flagged" className="cmp-flagtoggle__horizontal" onClick={onClick}>
      <FlaggedControlIcon
        isFlagged={isFlagged}
        flaggedClassName={colorClassNames.background('profile-highlight')}
        unFlaggedClassName={colorClassNames.border('border-color-profile-highlight')}
      />

      <FlaggedControlText id="flagged" className={getFontColorClassNameOLD(colorTheme)} isFlagged={isFlagged} />
    </div>
  );
};

export const Flagged = (props) => {
  const { isFlagged } = props;

  return isFlagged
    ? (
      <FlaggedIcon className={colorClassNames.background('profile-highlight')} />
    ) : null;
};

export const FileViewFlaggedControl = (props) => {
  const { isFlagged, onClick } = props;

  return (
    <div id="flagged" className="cmp-flagtoggle__horizontal" onClick={onClick}>
      <FlaggedControlIcon
        isFlagged={isFlagged}
        flaggedClassName={colorClassNames.background('profile-highlight')}
        unFlaggedClassName={colorClassNames.border('border-color-gsLightest')}
      />
      <FlaggedControlText id="flagged" isFlagged={isFlagged} className="font-color-gsLightest" />
    </div>
  );
};
